import { createContext, useContext } from "react";

interface QcEntityContextValue {
    layer: any;
    check: any;
}

const QcEntityContext = createContext<QcEntityContextValue | null>(null);

export function QcEntityProvider({ layer, check, children }: QcEntityContextValue & { children: React.ReactNode }) {
    return <QcEntityContext.Provider value={{ layer, check }}>{children}</QcEntityContext.Provider>;
}

export function useQcEntities() {
    const context = useContext(QcEntityContext);
    if (!context) {
        throw new Error("useQcEntities must be used inside QcEntityProvider");
    }
    return context;
}
